"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.ProvideAuth = exports.ENFORCE_SIGNED_IN = void 0;
const react_1 = __importStar(require("react"));
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const package_1 = require("../package");
const Authentication_1 = require("../shapes/Authentication");
const Person_1 = require("foaf/lib/shapes/Person");
const UserAccount_1 = require("lincd-sioc/lib/shapes/UserAccount");
const ShapeClass_1 = require("lincd/lib/utils/ShapeClass");
const token_1 = require("../utils/token");
const AppContext_1 = require("lincd-server-utils/lib/components/AppContext");
exports.ENFORCE_SIGNED_IN = 'ENFORCE_SIGNIN';
const AuthContext = (0, react_1.createContext)(null);
// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
function ProvideAuth({ children, userType = Person_1.Person, accountType = UserAccount_1.UserAccount, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
availableAccountTypes = [], }) {
    //Note: AvailableAccountTypes prop can be used to ensure that the App bundle that renders the provider
    // will include all the available account types. So that useAuth will work correctly when it uses getShapeOrSubShape to get the user account
    // we don't acutally use the property here, its just so that webpack bundles these account types
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const auth = useProvideAuth(userType, accountType);
    return react_1.default.createElement(AuthContext.Provider, { value: auth }, children);
}
exports.ProvideAuth = ProvideAuth;
// Hook for child components to get the auth object ...
// ... and re-render when it changes.
const useAuth = () => {
    const authContext = (0, react_1.useContext)(AuthContext);
    if (!authContext) {
        throw new Error('useAuth must be used within a ProvideAuth component');
    }
    return authContext;
};
exports.useAuth = useAuth;
// Provider hook that creates auth object and handles state
function useProvideAuth(userType = Person_1.Person, accountType = UserAccount_1.UserAccount) {
    // get the express request from the app context
    // and set the default auth to the linked auth or the first local auth
    const { expressRequest } = (0, AppContext_1.useAppContext)();
    const defaultAuth = (expressRequest === null || expressRequest === void 0 ? void 0 : expressRequest.linkedAuth) ||
        (typeof window !== 'undefined' &&
            Authentication_1.Authentication.getLocalInstances().first());
    const [auth, setAuthState] = (0, react_1.useState)(defaultAuth);
    // get the user and userAccount from the authentication instance
    let account, person;
    account = auth ? (0, ShapeClass_1.getShapeOrSubShape)(auth.userAccountNode, accountType) : null;
    person = auth ? (0, ShapeClass_1.getShapeOrSubShape)(account.accountOfNode, userType) : null;
    const [user, setUser] = (0, react_1.useState)(person);
    const [userAccount, setUserAccount] = (0, react_1.useState)(account);
    (0, react_1.useEffect)(() => {
        // register the action handler to enforce signed in
        Server_1.Server.registerActionHandler(exports.ENFORCE_SIGNED_IN, ({ preventDefault }) => {
            //logging out the user on the frontend should be sufficient redirect the user to the sign-in page if the app uses RequireAuth
            signout();
            preventDefault();
        });
        /**
         * Validate token on component mount
         */
        const startTokenValidation = () => __awaiter(this, void 0, void 0, function* () {
            yield validateToken();
            // set interval to validate token every ACCESS_TOKEN_EXPIRES
            const interval = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield validateToken();
            }), token_1.ACCESS_TOKEN_EXPIRES);
            // clear interval on unmount
            return () => clearTimeout(interval);
        });
        startTokenValidation();
        // check if a token is already stored and set it as default header
        const getToken = () => __awaiter(this, void 0, void 0, function* () {
            const token = yield (0, token_1.getAuthToken)(token_1.ACCESS_TOKEN);
            if (token) {
                Server_1.Server.addDefaultHeaders({
                    Authorization: `Bearer ${token}`,
                });
            }
        });
        getToken();
    }, []);
    // update the authentication instance and the user and userAccount
    const updateAuth = (auth, accessToken = null, refreshToken = null) => {
        //update the hook state, so a rerender is triggered with the updated auth values
        setAuthState(auth);
        // get the user and userAccount from the authentication instance
        const userAccount = (0, ShapeClass_1.getShapeOrSubShape)(auth.userAccountNode, accountType);
        const user = (0, ShapeClass_1.getShapeOrSubShape)(userAccount.accountOfNode, userType);
        // update the user and userAccount before render
        setUser(user);
        setUserAccount(userAccount);
        // save token to storage
        if (accessToken) {
            (0, token_1.setAuthToken)({
                key: token_1.ACCESS_TOKEN,
                value: accessToken,
                expires: token_1.ACCESS_TOKEN_EXPIRES,
            });
            Server_1.Server.addDefaultHeaders({
                Authorization: `Bearer ${accessToken}`,
            });
        }
        if (refreshToken) {
            (0, token_1.setAuthToken)({
                key: token_1.REFRESH_TOKEN,
                value: refreshToken,
                expires: token_1.REFRESH_TOKEN_EXPIRES,
            });
        }
        return { user, userAccount, accessToken, refreshToken };
    };
    const signinWithPassword = (email, password) => {
        return Server_1.Server.call(package_1.packageName, 'signinWithPassword', email, password).then((response) => {
            if (response && response.auth) {
                return updateAuth(response.auth);
            }
            else {
                //TODO: show user feedback
            }
        });
    };
    const signinOAuth = (provider, source) => {
        return Server_1.Server.call(package_1.packageName, 'signinOAuth', provider, source).then((response) => {
            if (response && response.auth) {
                return updateAuth(response.auth, response.accessToken, response.refreshToken);
            }
            else {
                //TODO: show user feedback
                console.warn("Couldn't sign in with OAuth");
            }
        });
    };
    const signout = () => __awaiter(this, void 0, void 0, function* () {
        // reset the authentication instance
        setAuthState(null);
        setUser(null);
        setUserAccount(null);
        // remove token from storage
        (0, token_1.removeAuthToken)(token_1.ACCESS_TOKEN);
        (0, token_1.removeAuthToken)(token_1.REFRESH_TOKEN);
        const result = yield Server_1.Server.call(package_1.packageName, 'signout');
        if (result) {
            // hard refresh to redirect after signout
            window.location.href = '/';
        }
        else {
            return {
                error: 'signout failed',
            };
        }
    });
    /**
     * Check the token still valid or not, need on Apps
     *
     * @returns boolean
     */
    const validateToken = () => __awaiter(this, void 0, void 0, function* () {
        const storedToken = yield (0, token_1.getAuthToken)(token_1.ACCESS_TOKEN);
        const refreshToken = yield (0, token_1.getAuthToken)(token_1.REFRESH_TOKEN);
        if (storedToken) {
            return Server_1.Server.call(package_1.packageName, 'validateToken', refreshToken)
                .then((response) => {
                // check if response error
                if (response.error) {
                    return false;
                }
                return updateAuth(response.auth, response.accessToken, response.refreshToken);
            })
                .catch((err) => {
                return false;
            });
        }
        else {
            return false;
        }
    });
    /**
     * get the access token from storage
     * @returns
     */
    const getAccessToken = () => __awaiter(this, void 0, void 0, function* () {
        return (0, token_1.getAuthToken)(token_1.ACCESS_TOKEN);
    });
    const removeAccount = () => {
        return Server_1.Server.call(package_1.packageName, 'removeAccount');
    };
    // Return the user object and auth methods
    return {
        user,
        userAccount,
        signinOAuth,
        signout,
        updateAuth,
        signinWithPassword,
        validateToken,
        getAccessToken,
        removeAccount,
    };
}
//# sourceMappingURL=useAuth.js.map